import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Add, Create, PlaylistAddCheck } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { WithApp } from 'contexts/appContext';
import FilterArticle from 'hooks/FilterArticle';
import { useModal } from 'hooks/useModal';
import { useToasty, Toasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { wsGetAll, wsFindBy } from 'services/WService.js';

import Modal from './Modal';

const useStyles = makeStyles({
  cardIconTitle: { ...cardTitle, marginTop: '15px', marginBottom: '0px' },
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 110 },
  { Header: 'Código', accessor: 'ItemCode', width: 120, align: 'center' },
  { Header: 'Producto', accessor: 'ItemName' },
  { Header: 'Proveedor', accessor: 'proveedor' },
  { Header: 'Marca', accessor: 'marca', width: 140 },
  { Header: 'Mesa', accessor: 'mesa', width: 180 },
  { Header: 'Cantidad', accessor: 'quantity', width: 100, align: 'center' },
  { Header: 'Prioridad', accessor: 'priority', width: 100, align: 'center' },
  { Header: 'Autosel. desde', accessor: 'start_date', width: 130, align: 'center' },
  { Header: 'Estado', accessor: 'state', width: 90, align: 'center' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function MustHaveProduct(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [items, setItems] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listItems(filtro) {
    setDataLoading(true);
    const response = filtro?.logi_product_id
      ? await wsFindBy('logi/must-have-product', { logi_product_id: filtro.logi_product_id })
      : await wsGetAll('logi/must-have-product');
    setDataLoading(false);
    if (response.success) setItems(response.data);
  }

  useEffect(() => {
    listItems();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={listItems} />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.LOGI_PRODUCTS_STORE}
              component={
                <CardIcon color="primary">
                  <PlaylistAddCheck style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon onClick={() => setOpen({})} pointer="true" color="success">
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>
              Productos infaltables {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <FilterArticle getFilter={listItems} article mark />

            <ReactTable
              excelName="Productos-infaltables"
              defaultWidth={1200}
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={items.map((item, i) => ({
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.LOGI_PRODUCTS_UPDATE}>
                      <Button
                        justIcon
                        round
                        simple
                        color={props.themeContext.buttonColor}
                        onClick={() => setOpen(item)}
                      >
                        <Create />
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard permission={ConstantPermissions.LOGI_PRODUCTS_DESTROY}>
                      <ButtonDelete
                        entity="logi/must-have-product"
                        id={item.id}
                        reload={listItems}
                      />
                    </AllowedGuard>
                  </div>
                ),
                ItemCode: item.product?.ItemCode ?? '',
                ItemName: item.product?.ItemName ?? '',
                proveedor: item.product?.business_partner?.CardName ?? '',
                marca: item.product?.mark?.description ?? '',
                mesa: item.bureau ? `${item.bureau.code} - ${item.bureau.description}` : '',
                quantity: item.quantity ?? '',
                priority: item.priority ?? '',
                start_date: item.start_date ?? '',
                state: item.state === 'A' ? 'Activo' : 'Inactivo',
                actions: '',
              }))}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
